import {useEffect, useState} from 'react'
import {KTIcon} from "../../../../_metronic/helpers";
import axios from "axios";
import {toast} from "react-toastify";
import moment from "moment-timezone";


const UsagesModal = ({ data, onClose }) => {
    const [usages, setUsages] = useState(null)
    const [topUps, setTopUps] = useState(null)
    const [isLoading, setLoading] = useState(false)

    useEffect(() => {
        document.body.classList.add('modal-open')
        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [])

    const fetchUsages = async () => {
        try {
            setLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_V3_URL}/partner/${data.partner_id}`);
            setTopUps(res?.data?.topups)
            setUsages(res?.data?.history)
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Error while fetching partners API usages');
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchUsages()
    }, [])

    return (
        <>
            <div
                className='modal fade show d-block'
                id='kt_modal_add_user'
                role='dialog'
                tabIndex={-1}
                aria-modal='true'
            >
                <div className={`modal-dialog modal-dialog-centered mw-550px`}>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h2 className='fw-bolder'>API Limit Changes & Logs for {data.name}</h2>
                            <div
                                className='btn btn-icon btn-sm btn-active-icon-primary'
                                data-kt-users-modal-action='close'
                                onClick={onClose}
                                style={{cursor: 'pointer'}}
                            >
                                <KTIcon iconName='cross' className='fs-1' />
                            </div>
                        </div>

                        <div className={`modal-body scroll-y mx-5  mx-xl-5`}>
                            <div
                                className="d-flex flex-column me-n7 pe-7"
                                style={{ height: 'auto', maxHeight: '380px' }}
                                id="kt_modal_add_user_scroll"
                                data-kt-scroll="true"
                                data-kt-scroll-activate="{default: false, lg: true}"
                                data-kt-scroll-max-height="auto"
                                data-kt-scroll-dependencies="#kt_modal_add_user_header"
                                data-kt-scroll-wrappers="#kt_modal_add_user_scroll"
                                data-kt-scroll-offset="300px"
                            >
                                <div className="mb-10">
                                    <h3>API Limit Changes:</h3>
                                    <div>
                                        {topUps && topUps.length > 0 ? (
                                            <ul>
                                                {topUps.map(el => (
                                                    <li key={el.id}>
                                                        {moment(el.createdAt).format('YYYY-MM-DD HH:mm')} - usages limit increased by {el.usage_increased}
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <>No topups found.</>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <h3>Logs:</h3>
                                    <div>
                                        {usages && usages.length > 0 ? (
                                            <ul>
                                                {usages.map(el => (
                                                    <li key={el.id}>
                                                        {moment(el.createdAt).format('YYYY-MM-DD HH:mm')} - API v{el.api_version}
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <>No usages found.</>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='modal-backdrop fade show'></div>
        </>
    )
}

export {UsagesModal}
